<template>
    <div v-if="step == 1" class="move-sims select-sims">
        <div class="move-sims-header">
            <h3>Move SIMs</h3>
            <p>Select SIMs that will be moved from {{companyName}}</p>
        </div>
        <div class="upload-sims-areas">
            <div class="input-sims-area">
                <p>Scan the barcode of / or enter the SIM number you can find on the back of the SIM card</p>
                <div class="sims-input">
                    <input @keyup="onEnterPress" type="text" class="add-sims-input" v-model="simsInput">
                    <button @click="addSimsFromBtn()" class="add-sims-btn">Apply</button>
                </div>
            </div>
            <div class="dnd-area">
                <div class="image">
                    <img src="../../assets/img/upload-sims.png" alt="">
                </div>
                <div class="text">
                    <h3>Drag and drop list of SIM's or Browse</h3>
                    <h4>The file selected needs to be CSV or XLSX file where the SIMs are seperated by commas.</h4>
                </div>
                <div v-if="mobileVisible == true" class="mobile-text">
                    <p>OR</p>

                    <h3>Upload file</h3>
                    <h4>The file selected needs to be CSV or XLSX file where the SIMs are seperated by commas.</h4>
                </div>
                <div class="label">
                    <input type="file" id="file-bulk-modal" ref="importFile" v-on:change="readSimFile">
                    <label for="file-bulk-modal" class="btn btn-primary">Browse</label>
                </div>
            </div>
        </div>
        <div v-if="errorSims.length" class="sims-failed-validation-from-file">
            <h3>Uploaded list issues</h3>
            <h4>SIM cards that coundn't be processed from the uploaded list.</h4>
            <div v-for="item of errorSims" class="error-type">
                <h6 class="name">{{item.groupName}}</h6>
                <h6 class="desc">{{item.groupDescription}}</h6>
                <div class="list-of-sims">
                    <div v-for="sim of item.iccids" class="sim"> <i class="fts-icon-sim"></i> {{sim}}</div>
                </div>
            </div>
        </div>
        <div class="siot-table-wrapper">
            <div class="siot-table-header">
                <div class="siot-table-header-left">
                    <div class="siot-table-search">
                        <div class="siot-table-search-field">
                            <input type="text" id="coldstockSearch" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                        </div>
                    </div>
                    <div class="siot-table-toggle">
                        <FTScheckbox v-model="selectedCheckbox" @change.native="getColdStocks(true)" :label="'Show selected only'"></FTScheckbox>
                    </div>
                    <div class="siot-table-sort">
                        <button id="simManagmentSort" @click="shwoHideSort()" class="btn btn-primary mobile-sort-btn"><i aria-hidden="true" class="fa fa-sort"></i>Sort</button>
                    </div>
                </div>

                <div class="siot-table-header-right">
                    <div class="siot-table-size">
                        <label for="size-page">Display:</label>
                        <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="siot-table-content">
                <div class="siot-table">
                    <div v-if="mobileVisible == true" class="cold-stock-mobile">
                        <div class="list-mobile">
                            <div class="item-mobile" v-for="(item, index) in coldStockList" :data-iccid="item.iccid" v-bind:key="index">
                                <div class="item-header-mobile">
                                    <div class="icon">
                                        <img v-if="item.carrierId == 1" src="../../assets/img/carrier-simon.svg"/>
                                        <img v-else-if="item.carrierId == 2" src="../../assets/img/carrier-tmobile.svg"/>
                                        <img v-else-if="item.carrierId == 3" src="../../assets/img/carrier-vodafone.svg"/>
                                        <img v-else src="../../assets/img/carrier-simon.svg"/>
                                    </div>

                                    <div class="info-wrapper-mobile">
                                        <div class="info-mobile">
                                            <strong>{{item.iccid}}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="siot-table table-responsive-sm table-coldstock-bank-component">
                        <table  v-if='coldStockList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi">
                            <thead role="rowgroup">
                            <tr role="row">
                                <th v-on:click="changesSort(1)" role="columnheader" :aria-sort="setAreaSort(1)">SIM</th>
                                <th v-on:click="changesSort(2)" role="columnheader" :aria-sort="setAreaSort(2)">Carrier</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="(item, index) in coldStockList" :data-iccid="item.iccid" v-bind:key="index" :aria-selected="isSelected(item.iccid)">
                                <td v-on:click="selectRowModal(item.iccid, item.status)" role="cell" aria-colindex="1" class="small-coll"><span class="fts-checkbox"></span></td>
                                <td>{{item.iccid}}</td>
                                <td>
                                    <span v-if="item.carrierId == 1">SimonIoT</span>
                                    <span v-else-if="item.carrierId == 2">T-Mobile</span>
                                    <span v-else-if="item.carrierId == 3">Vodafone</span>
                                    <span v-else-if="item.carrierId == 4">Kore</span>
                                    <span v-else>--</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="loader-sim-list" v-if="loadingColdSims && noSims == false">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>
                </div>

                <div class="no-sims" v-if="noSims">
                    <h2 class="text">You have no Cold SIMs</h2>
                </div>
            </div>
            <div class="siot-table-footer">
                <div class="siot-table-footer-center">
                    <nav v-if="paginationCount" aria-label="Page navigation example">
                        <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                    </nav>
                </div>
                <div class="controls">
                    <button class="btn btn-light" @click="back()">Cancel</button>
                    <button class="btn btn-primary" @click="goToCompanySelect()" :disabled="selectedSims.length == 0">Next</button>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="step == 2" class="move-sims select-company">
        <div class="move-sims-header">
            <h3>Move SIMs</h3>
            <p>Select SIMs that will be moved from {{companyName}}</p>
        </div>
        <div class="siot-table-wrapper">
            <div class="siot-table-header">
                <div class="siot-table-header-left">
                    <div class="siot-table-search">
                        <div class="siot-table-search-field">
                            <input type="text" id="coldstockSearch" v-model="filterCompanies" v-on:keyup="searchKeyUpCompanies()" v-on:keydown="searchKeyDownCompanies()" placeholder="Search">
                        </div>
                    </div>
                </div>

                <div class="siot-table-header-right">
                    <div class="siot-table-size">
                        <label for="size-page">Display:</label>
                        <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="siot-table-content">
                <div class="siot-table">
                    <div class="siot-table table-responsive-sm table-coldstock-bank-component">
                        <table v-if='companiesList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi">
                            <thead role="rowgroup">
                                <tr role="row">
                                    <th v-on:click="changesSortCompanies(1)" role="columnheader" :aria-sort="setAreaSortCompanies(1)">ID</th>
                                    <th v-on:click="changesSortCompanies(2)" role="columnheader" :aria-sort="setAreaSortCompanies(2)">Company Name</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr @click="selectCompany(item.companyId, item.companyName)" v-for="(item, index) in companiesList" :data-iccid="item.companyId" v-bind:key="index" :aria-selected="isSelectedCompany(item.companyId)">
                                    <td>{{item.companyId}}</td>
                                    <td>{{item.companyName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="loader-sim-list" v-if="loadingColdSims && noSims == false">
                    <div class="sk-wave">
                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                    </div>
                </div>

                <div class="no-sims" v-if="noSims">
                    <h2 class="text">You have no Cold SIMs</h2>
                </div>
            </div>
            <div class="siot-table-footer">
                <div></div>
                <nav v-if="companiesPageCount" aria-label="Page navigation example">
                    <paginate :page-count="companiesPageCount" v-model="sortSettingsCompanies.page" :click-handler="paginationControllCompanies" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                </nav>
                <div class="control-btns">
                    <button class="btn btn-light" @click="backToSelectSims()">Back</button>
                    <button class="btn btn-primary" :disabled="selectedCompany == null" @click="moveSims()">Move SIMs</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStore from './../../variables'
import VueSession from "vue-session";
import Paginate from 'vuejs-paginate'
import VueCookies from 'vue-cookies';
import FTSSort from "../../ftsComponents/FTSSort";
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)
import FTScheckbox from "../../ftsComponents/FTScheckbox";

Vue.use(VueSession);

export default {
    name: 'MoveSims',
    data() {
        return {
            companyId: this.$route.params.id,
            sortMobile: {
                column: 0,
                direction: true
            },
            toggleSort: false,
            mobileVisible: false,
            visibilityOptionsButtons: false,
            sortSettings: {
                page: 1,
                size: 40,
                sort: 2,
                desc: false
            },
            sortSettingsCompanies: {
                page: 1,
                size: 40,
                sort: 2,
                desc: false
            },
            loadingColdSims: false,
            noSims: false,
            simsList: [],
            paginationCount: 0,
            filter: '',
            filterCompanies: '',
            searchString: '',
            companyName: '',
            coldStockList: '',
            coldStock: false,
            coldStockAccess: false,
            filterString: '',
            filterStringCompanies: '',
            sortingSettings: [
                {
                    label: 'SIM',
                    column: 1
                },
                {
                    label: 'Carrier',
                    column: 2
                },
            ],
            mobileSort: {
                column: 0,
                direction: 0,
                visible: false
            },
            simsInput: '',
            selectedCheckbox: false,
            showOnlySelected: '',
            prevalidation: true,
            selectedSims: [],
            simsPrevalidated: [],
            simsInputParsed: [],
            errorSims: [],
            step: 1,
            companiesPageCount: 1,
            companiesList: [],
            selectedCompany: null,
            selectedCompanyName: '',
            typingTimer: null
        }
    },
    components: {
        Paginate,
        FTScheckbox,
        FTSSort
    },
    methods: {
        shwoHideSort() {
            this.mobileSort.visible = (this.mobileSort.visible == true) ? false : true;
        },
        showMobileElements() {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            if (width < 992) {
                this.mobileVisible = true;
            } else {
                this.mobileVisible = false;
            }
        },
        searchKeyUp() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.filterString = '&search=' + this.filter
                this.getColdStocks(true)
            }, 500)
        },
        searchKeyDown() {
            clearTimeout(this.typingTimer)
        },
        searchKeyUpCompanies() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.filterStringCompanies = '&search=' + this.filterCompanies
                this.getCompaniesList(true)
            }, 500)
        },
        searchKeyDownCompanies() {
            clearTimeout(this.typingTimer)
        },
        getPagination() {
            Axios.get(globalStore.data.restApiUrl + "/cold-stock/page-count?companyId=" + this.companyId + "&size=" + this.sortSettings.size + this.filterString)
                .then(response => {
                    if (response.status == 200) {
                        this.paginationCount = Number (response.data);
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving Cold Stock List - Contact Support',
                            duration: 5000,
                        });

                        return false;
                    }
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving Cold Stock List - Contact Support',
                    duration: 5000,
                });
                console.log(error)

                return false;
            })
        },
        sizePage() {
            this.getColdStocks(true)
        },
        paginationControll(ev) {
            this.sortSettings.page = ev;
            this.getColdStocks(false);
        },
        paginationControllCompanies(ev) {
            this.sortSettingsCompanies.page = ev;
            this.getCompaniesList(false);
        },
        changesSort(sortId) {
            if (sortId == this.sortSettings.sort) {
                this.sortSettings.desc = !this.sortSettings.desc
            }
            this.sortSettings.sort = sortId
            this.getColdStocks(false);
        },
        setAreaSort(sortId) {
            if (sortId != this.sortSettings.sort) {
                return 'none'
            } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                return 'descending'
            } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                return 'ascending'
            }
        },
        changesSortCompanies(sortId) {
            if (sortId == this.sortSettingsCompanies.sort) {
                this.sortSettingsCompanies.desc = !this.sortSettingsCompanies.desc
            }
            this.sortSettingsCompanies.sort = sortId
            this.getCompaniesList(false);
        },
        setAreaSortCompanies(sortId) {
            if (sortId != this.sortSettingsCompanies.sort) {
                return 'none'
            } else if (sortId == this.sortSettingsCompanies.sort && this.sortSettingsCompanies.desc) {
                return 'descending'
            } else if (sortId == this.sortSettingsCompanies.sort && this.sortSettingsCompanies.desc == false) {
                return 'ascending'
            }
        },
        isSelected(id) {
            let isSelected = false;
            if (this.selectedSims.indexOf(id) != -1) {
                isSelected = true;
            }
            return isSelected;
        },
        selectCompany(id, name) {
            this.selectedCompany = id
            this.selectedCompanyName = name
        },
        isSelectedCompany(id) {
            return id == this.selectedCompany;
        },
        selectRowModal(id, status) {
            if (typeof id == "string") {
                let parsedData = {
                    iccids: [],
                    forceOff: null
                };
                if (this.selectedSims.indexOf(id) != -1) {
                    this.selectedSims.splice(this.selectedSims.indexOf(id), 1);
                    parsedData = {
                        iccids: [id],
                        forceOff: true
                    };
                } else {
                    this.selectedSims.push(id)
                    parsedData = {
                        iccids: [id],
                        forceOn: true
                    };
                }
                Axios.post(globalStore.data.restApiUrl + '/sims/mark?companyId=' + this.companyId, parsedData)
                    .then(() => {
                        if (this.addingFromFile) {
                            this.getSimsListModal()
                            this.addingFromFile = false
                        }
                        if (this.simsPrevalidated.length != this.selectedSims.length) {
                            this.prevalidation = true
                        } else {
                            let prevalidatedCounter = 0
                            for (let sim of this.selectedSims) {
                                if (this.simsPrevalidated.indexOf(sim) > -1) {
                                    prevalidatedCounter++
                                }
                            }
                            if (prevalidatedCounter == this.selectedSims.length) {
                                this.prevalidation = false
                            } else {
                                this.prevalidation = true
                            }
                        }
                        if (parsedData.iccids.length > 0) {
                            this.$cookies.set('simsMarked', true)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Selected SIM failed',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    });
            } else if (typeof id == "object") {

                let parsedData = {
                    iccids: null,
                    forceOn: null
                };

                if (this.selectedAllModal == 'true') {
                    parsedData = {
                        iccids: id,
                        forceOn: true
                    };

                } else {
                    parsedData = {
                        iccids: id,
                        forceOff: true
                    };

                    id.map(sim => {
                        this.selectedSims.splice(this.selectedSims.indexOf(sim), 1);
                    })
                }

                Axios.post(globalStore.data.restApiUrl + '/sims/mark?companyId=' + this.companyId, parsedData)
                    .then(() => {
                        if (this.addingFromFile) {
                            setTimeout(() => {
                                this.getColdStocks()
                                this.addingFromFile = false
                            }, 500)
                        }
                        if (parsedData.iccids.length > 0) {
                            this.$cookies.set('simsMarked', true)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Selected SIM failed',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    });
                this.setSelectAllModal();
            }
        },
        getColdStocks(notPagination) {
            this.loadingColdSims = true;
            if (notPagination){
                this.sortSettings.page = 1;
                this.getPagination();
            }
            if (this.selectedCheckbox == true) {
                this.showOnlySelected = '&selectedOnly=true'
            } else {
                this.showOnlySelected = ''
            }
            Axios.get(`${globalStore.data.restApiUrl}/cold-stock?companyId=${this.companyId}&page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}${this.showOnlySelected}${this.filterString}`)
                .then(response => {
                    this.coldStockList = response.data
                    this.loadingColdSims = false;
                }).catch(error => {
                this.loadingColdSims = false
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Something was wrong',
                    text: 'Error Retrieving Cold Stock List - Contact Support',
                    duration: 5000,
                });
                return false;
            })
        },
        onEnterPress(ev) {
            ev.keyCode === 13 ? this.addSimsFromBtn() : null;
        },
        addSimsFromBtn() {
            let simsParsed = []
            let simsArray = this.simsInput
            if (simsArray.indexOf(',') > -1) {
                simsArray = this.simsInput.split(',')
            } else {
                simsArray = this.simsInput.split(' ')
            }

            if (typeof simsArray == 'object') {
                for (let item of simsArray) {
                    if (item.indexOf(' ') > -1) {
                        let arrItem = item.split(' ')
                        for (let sim of arrItem) {
                            sim = sim.replace(/f/g, '');
                            sim = sim.replace(/F/g, '');
                            sim = sim.replace(/\D/g, '');
                            if (sim != "") {
                                simsParsed.push(sim)
                            }
                        }
                    } else {
                        item = item.replace(/f/g, '');
                        item = item.replace(/F/g, '');
                        item = item.replace(/\D/g, '');
                        if (item != "") {
                            simsParsed.push(item)
                        }
                    }
                }
            } else {
                if (simsArray.indexOf(' ') > -1) {
                    console.log(123)
                    simsParsed = this.simsInput.split(' ')
                } else {
                    console.log(233)
                    simsParsed = [this.simsInput]
                }
            }
            this.simsInput = ''
            this.selectFromBtn(simsParsed)
        },
        selectFromBtn(sims) {
            Axios.post(`${globalStore.data.restApiUrl}/cold-stock/move-sims/validate-and-select?companyId=${this.companyId}`, {iccids: sims})
                .then(response => {
                    this.prevalidation = false
                    this.selectedSims = []
                    this.errorSims = []
                    this.validationFailedCount = 0
                    this.validationPassedCount = 0
                    this.validationTotalCount = 0
                    for (let item of response.data.validationGroups) {
                        if (item.groupName != 'Valid') {
                            this.errorSims.push(item)
                            this.validationFailedCount = this.validationFailedCount + item.iccids.length
                        } else {
                            for (let sim of item.iccids) {
                                this.simsPrevalidated.push(sim)
                                this.selectedSims.push(sim)
                            }
                            this.validationPassedCount = item.iccids.length
                        }
                    }
                    this.validationTotalCount = this.validationFailedCount + this.validationPassedCount
                    if (this.errorSims.length == 0) {
                        this.goToCompanySelect()
                    }
                    this.selectedCheckbox = true
                    this.setSelectAll();
                    this.getColdStocks(true)
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Unselecting SIM cards on the server side failed.',
                    text: 'Error Processing SIM Selection - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        goToCompanySelect() {
            if (this.prevalidation) {
                this.selectFromBtn(this.selectedSims)
            } else {
                this.getCompaniesList(true)
            }
        },
        back() {
            this.$router.push(`/admin/company/${this.companyId}`)
        },
        backToSelectSims() {
            this.selectedCompany = null
            this.step = 1
        },
        setSelectAll() {
            let isAllSelected = 0;
            for (let i = 0 ; i < this.coldStockList.length ; i++) {
                if (this.selectedSims.indexOf(this.coldStockList[i].iccid) != -1) {
                    isAllSelected++;
                }
            }
            if ((this.coldStockList.length > 0) && (isAllSelected == this.coldStockList.length)) {
                this.selectedAll = 'true';
            } else {
                this.selectedAll = 'false';
            }
        },
        selectAllRowsColdStock() {
            let selected = false;

            if (this.selectedAll == 'true') {
                this.selectedAll = 'false';
            } else {
                this.selectedAll = 'true'
                selected = true;
            }
            let prepareIccids = [];

            if (selected) {
                for (let i = 0 ; i < this.coldStockList.length ; i++) {
                    if (this.selectedSims.indexOf(this.coldStockList[i].iccid) == -1) {
                        prepareIccids.push(this.coldStockList[i].iccid);
                    }
                }
            } else {
                for (let i = 0 ; i < this.coldStockList.length ; i++) {
                    if (this.selectedSims.indexOf(this.coldStockList[i].iccid) != -1) {
                        prepareIccids.push(this.coldStockList[i].iccid);
                    }
                }
            }
            this.selectRowColdStock(prepareIccids);
        },
        unselectAllRowsColdStock() {
            Axios.delete(globalStore.data.restApiUrl + "/sims/mark?companyId=" + this.companyId)
                .then(response => {
                    this.selectedSims = []
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Unselecting SIM cards on the server side failed.',
                    text: 'Error Processing SIM Selection - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        isSelectedColdStock(iccid) {
            if (this.selectedSims.indexOf(iccid) != -1)  {
                return false
            } else {
                return true
            }
        },
        selectRowColdStock(id) {
            if (typeof id == "string") {
                let parsedData = null
                if (this.selectedSims.indexOf(id) != -1) {
                    this.selectedSims.splice(this.selectedSims.indexOf(id), 1);
                    parsedData = {
                        iccids: [id],
                        forceOff: true
                    };
                } else {
                    this.selectedSims.push(id)
                    parsedData = {
                        iccids: [id],
                        forceOn: true
                    };
                }
                Axios.post(globalStore.data.restApiUrl + '/sims/mark', parsedData)
                    .then(response => {
                        this.selectedSims = response.data
                        this.setSelectAll();
                        if (parsedData.forceOff && this.selectedCheckbox) {
                            this.getColdStocks(true)
                        }
                        if (this.simsPrevalidated.length != this.selectedSims.length) {
                            this.prevalidation = true
                        } else {
                            let prevalidatedCounter = 0
                            for (let sim of this.selectedSims) {
                                if (this.simsPrevalidated.indexOf(sim) > -1) {
                                    prevalidatedCounter++
                                }
                            }
                            if (prevalidatedCounter == this.selectedSims.length) {
                                this.prevalidation = false
                            } else {
                                this.prevalidation = true
                            }
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Selected SIM failed',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    });
            } else if (typeof id == "object") {
                let parsedData = {
                    iccids: null,
                    forceOn: null
                };

                if (this.selectedAll == 'true') {

                    parsedData = {
                        iccids: id,
                        forceOn: true
                    };

                    id.map(sim => {
                        this.selectedSims.push(sim)
                    })

                } else {
                    parsedData = {
                        iccids: id,
                        forceOff: true
                    };

                    id.map(sim => {
                        this.selectedSims.splice(this.selectedSims.indexOf(sim), 1);
                    })
                }

                Axios.post(globalStore.data.restApiUrl + '/sims/mark', parsedData)
                    .then(response => {
                        this.selectedSims = response.data
                        this.getColdStocks(true)
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Selected SIM failed',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    });
                this.setSelectAll();
            }
        },
        searchKeyUpColdStock() {
            clearTimeout(this.timerSearch)
            this.timerSearch = setTimeout(() => {
                this.getColdStocks(true)
            }, 500)
        },
        searchKeyDownColdStock() {
            clearTimeout(this.timerSearch)
        },
        readSimFile(ev) {
            // this.simList = []
            // this.wrongSims = []
            // this.counter = 0
            if (ev.target) {
                var f = ev.target.files[0];
            } else {
                var f = ev[0];
            }

            var ext = f.name.slice(f.name.lastIndexOf("."));

            if (ext === ".csv") {

                var ret = [];
                var r = new FileReader();
                var tempThis = this;
                r.onload = (e) => {
                    var ct = r.result;
                    var words;

                    ct.indexOf("\n") > -1 ? words = ct.split("\n") : null;

                    if (typeof(words) == 'object') {
                        let tempArr = [];

                        for (let i = 0; i < words.length; i++) {
                            if (words[i].indexOf(",") > -1) {
                                let temptempArr = words[i].split(",");
                                for (let item in temptempArr) {
                                    if (temptempArr[item].length > 0) {
                                        tempArr.push(temptempArr[item])
                                    }
                                }
                            } else {
                                tempArr.push(words[i]);
                            }
                        }

                        words = tempArr
                    } else {
                        (ct.indexOf(",") > -1) ? words = ct.split(",") : null;
                    }

                    var len = words.length;

                    for (let i = 0 ; i < len ; i++){
                        words[i] = words[i].replace(/\D/g,'');
                        words[i] != ""  ? ret.push(words[i]) : null;
                    }
                    this.selectFromBtn(ret)
                }
                r.readAsText(f);
                this.$refs.importFile.value = null
            } else if (ext === '.txt') {

                var ret = [];
                if (ev.target) {
                    var f = ev.target.files[0];
                } else {
                    var f = ev[0];
                }

                if (f) {
                    var r = new FileReader();
                    var tempThis = this;
                    r.onload = function(e) {
                        var ct = r.result;

                        ct.indexOf("\n") > -1 ? ct = ct.split("\n") : null;

                        if (typeof(ct) == 'object') {
                            let tempArr = [];

                            for (let i = 0; i < ct.length; i++) {
                                if (ct[i].indexOf(",") > -1) {
                                    let temptempArr = ct[i].split(",");
                                    for (let item in temptempArr) {
                                        if (temptempArr[item].length > 0) {
                                            tempArr.push(temptempArr[item])
                                        }
                                    }
                                } else {
                                    tempArr.push(ct[i]);
                                }
                            }

                            ct = tempArr
                        } else {
                            ct.indexOf(",") > -1 ? ct = ct.split(",") : null;
                        }

                        if (typeof ct != 'string') {
                            var len = ct.length;
                            for (var i = 0 ; i < len ; i++) {
                                ct[i] = ct[i].replace(/\D/g,'');
                            }
                        }
                        this.selectFromBtn(ct)
                    }
                    r.readAsText(f);
                    this.$refs.importFile.value = null
                } else {
                    alert("Failed to load file");
                }
            } else if ( ext== '.xls' || ext === ".xlsx" ) {
                var tempThis = this;

                let formData = new FormData();
                formData.append('file', f);
                Axios.post(`${globalStore.data.restApiUrl}/sims/parse/xlsx`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(response => {
                        let simsNumber = response.data

                        if (simsNumber.length > 0) {
                            this.selectFromBtn(simsNumber)
                        } else {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'File is empty',
                                text: 'The file what you upload is empty, please upload right file',
                                duration: 3000,
                            });
                        }
                        this.$refs.importFile.value = null
                    })
                    .catch(error => {
                        this.loadingSims = false
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'File is wrong',
                            text: 'The file what you upload is wrong, please upload right file',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
        },
        getCompaniesList(resetPaginate) {
            if (resetPaginate) {
                this.sortSettingsCompanies.page = 1
            }
            Axios.post(`${globalStore.data.restApiUrl}/admin/companies/page-count?size=${this.sortSettingsCompanies.size}${this.filterStringCompanies}`, {iccids: this.selectedSims})
                .then(response => {
                    this.companiesPageCount = response.data
                })
            Axios.post(`${globalStore.data.restApiUrl}/admin/companies?page=${this.sortSettingsCompanies.page}&size=${this.sortSettingsCompanies.size}&desc=${this.sortSettingsCompanies.desc}&sort=${this.sortSettingsCompanies.sort}${this.filterStringCompanies}`, {iccids: this.selectedSims})
                .then(response => {
                    this.companiesList = response.data.filter(item => {
                        return item.companyId != this.companyId
                    })
                    this.step = 2
                })
        },
        getCompanyDetails() {
            Axios.get(`${globalStore.data.restApiUrl}/account/admin-view?companyId=${this.companyId}`)
                .then(response => {
                    this.companyName = response.data.companyName
                })
        },
        moveSims() {
            Axios.post(`${globalStore.data.restApiUrl}/cold-stock/move-sims?companyId=${this.companyId}&targetCompany=${this.selectedCompany}`, {iccids: this.selectedSims})
                .then(() => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'SIMs moved',
                        text: `You successfully moved ${this.selectedSims.length} ${this.selectedSims.length > 1 ? 'SIMs' : 'SIM'} from ${this.companyName} company to ${this.selectedCompanyName} company.`,
                        duration: 5000,
                    })
                    this.selectedCheckbox = false
                    this.simsPrevalidated = []
                    this.selectedCompany = null
                    this.selectedCompanyName = ''
                    this.step = 1
                    this.filterCompanies = ''
                    this.filterStringCompanies = ''
                    this.unselectAllRowsColdStock()
                    this.getColdStocks(true)
                })
        }
    },
    created() {
        this.showMobileElements();
    },
    mounted() {
        let self = this;
        document.addEventListener("dragenter", function (e) {
            e.preventDefault();

            if (document.querySelector(".dnd-area") && !document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                document.querySelector(".dnd-area").classList.add('dragged-fiel');
            }

            e.dataTransfer.setData("text/plain", e.target.id);
            e.dataTransfer.setData("text", e.target.id);
        });

        document.addEventListener("dragleave", function (e) {
            e.preventDefault();

            if (document.querySelector(".dnd-area") && !document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                document.querySelector(".dnd-area").classList.add('dragged-fiel');
            }
        });

        document.addEventListener("dragover", function (e) {
            e.preventDefault();
        });

        let dndArea = document.querySelector(".dnd-area");

        dndArea.addEventListener("drop", function (e) {
            e.preventDefault();

            if (document.querySelector(".dnd-area") && document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                document.querySelector(".dnd-area").classList.remove('dragged-fiel');
            }

            var files = e.dataTransfer.files;

            if (files && files.length > 0) {
                self.readSimFile(files);
            } else if (e.dataTransfer.getData("text").length > 0) {
                self.readDraggedList(e.dataTransfer.getData("text"))
            } else {
                self.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Wrong item dropped',
                    text: 'Item you dropped has not been recognized as a file or a list.',
                    duration: 5000,
                })
            }
        });

        document.addEventListener("drop", function (e) {
            e.preventDefault();

            if (document.querySelector(".dnd-area") && document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                document.querySelector(".dnd-area").classList.remove('dragged-fiel');
            }
        });
        this.getColdStocks()
        this.getPagination()
        this.getCompanyDetails()
    }
}
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
.move-sims {
    background-color: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    border: 1px solid #c9cfd4;
    .move-sims-header {
        padding: 20px 20px 24px;
        h3 {
            margin: 0 0 12px;
            font-size: 15px;
            font-weight: 700;
        }
        p {
            margin: 0;
            font-size: 15px;
        }
    }
    &.select-company {
        table {
            tr[aria-selected="true"] {
                td {
                    background-color: #bfe1ff;
                }
            }
        }
        .control-btns {
            display: flex;
            gap: 0 8px;
        }
    }
    .upload-sims-areas {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        padding: 20px;
        .input-sims-area {
            flex-grow: 1;
            width: calc(50% - 10px);
            margin-right: 20px;
            padding: 20px;
            border: 1px solid #C9CFD4;
            border-radius: 5px;
            .sims-input {
                display: flex;

                .add-sims-input {
                    flex-grow: 1;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    border: 1px solid #C9CFD4;
                    border-right: 0;
                    &:focus {
                        outline: none;
                    }
                }
                .add-sims-btn {
                    padding: 7px 20px;
                    background-color: #55cd6c;
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                    border: 1px solid #C9CFD4;
                    border-left: 0;
                    color: #fff;
                    font-weight: 700;
                }
            }
        }

        .dnd-area {
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            flex-grow: 1;
            width: calc(50% - 10px);
            padding: 20px;

            border: 2px dotted #2F353A;
            border-radius: 5px;

            &.dragged-fiel {
                background-color: #b2dbff;
            }

            .image {
                margin-right: 20px;

                img {
                    max-width: 60px;
                }
            }

            .text {
                margin-right: 25px;

                h3 {
                    margin: 0;
                    font-size: 12px;
                    line-height: 24px;
                    color: #2F353A;
                }

                h4 {
                    margin: 0;
                    font-size: 12px;
                    line-height: 16px;
                    color: #979A9C;
                }
            }

            .label {
                input {
                    display: none;
                }

                label {
                    margin: 0;
                }
            }
        }
    }


    .sims-failed-validation-from-file {
        margin: 0 20px;
        padding: 20px;
        background-color: #ffe3e3;
        border: 1px solid #FC4D4D;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        margin-bottom: 20px;

        h3 {
            margin: 0 0 4px;
            font-size: 15px;
            font-weight: 700;
        }
        h4 {
            font-size: 12px;
            color: #515B65;
            margin: 0 0 30px;
            font-weight: 400;
        }
        .error-type {
            margin-bottom: 10px;
            .name {
                margin: 0 0 4px;
                font-size: 15px;
                font-weight: 700;
            }
            .desc {
                margin: 0 0 15px;
                font-size: 12px;
                color: #515B65;
                font-weight: 400;
            }
            .list-of-sims {
                display: flex;
                flex-wrap: wrap;
                .sim {
                    display: flex;
                    align-items: center;
                    margin: 0 50px 12px 0;
                    i {
                        margin-right: 12px;
                        &:before {
                            color: #515B65;
                        }
                    }
                }
            }
        }
    }

    .bottom-card {
        bottom: 0;
        left: 20px;
        right: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        background-color: #fff;
    }


    .siot-table-footer {
        position: relative;
        padding: 0 20px 20px;
        .controls {
            position: absolute;
            right: 20px;
            bottom: 20px;
            display: flex;
            flex-wrap: nowrap;
            gap: 0 8px;
        }
        .btns-box {
            position: relative;
            display: flex;
            .btn {
                margin-left: 20px;
            }
            .move-to-activation-btn {
                &+.disable-hint {
                    display: none;
                    position: absolute;
                    bottom: calc(100% + 5px);
                    right: 0;
                    padding: 10px;
                    background-color: #241717;
                    color: #ffffff;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    white-space: nowrap;
                }
                &:hover {
                    &+.disable-hint {
                        display: block;
                    }
                }
            }
        }
    }
}

.fts-checkbox-table {
    cursor: pointer;
}

.dark-theme {

    #selectCarrier___BV_modal_header_ {
        background-color: #3a4149;
        border: 0;
    }

    .modal-header {
        button {
            color: #fff;
        }
    }
    .modal-content {
        background-color: #3a4149;
        color: #edeeef;
        .carrier-option {
            .light-mode {
                display: none;
            }
            .dark-mode {
                display: block;
            }
        }
    }

    .table thead th {
        color: #fff;
        border-color: #1A1C1D;
    }
    .table tbody tr td {
        background-color: #2F353A;
        border-color: #1A1C1D;
        color: #fff;
    }
    .table tbody tr:nth-of-type(odd) td {
        background-color: #2F353A;
    }
    .table tbody tr:hover td {
        background-color: #0088FF;
        color: #fff;
    }
    .wrapper-cold-stock .bottom-card {
        background-color: transparent;
    }

    .wrapper-modal {
        .file-format-popup {
            background-color: #3a4149;
            color: #EDEEEF;
        }
    }
}

#selectCarrier___BV_modal_header_ {
    padding-bottom: 0;
}

#selectCarrier___BV_modal_body_ {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;

    padding-top: 0;
    padding-bottom: 40px;

    img {
        max-width: 16px;
        margin-bottom: 12px;
    }

    strong {
        margin-bottom: 18px;
        font-size: 15px;
        line-height: 20px;
    }

    p {
        font-size: 14px;
        line-height: 24px;
    }

    .select-carrier-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .carrier-option {
            width: 180px;
            padding: 10px 20px;
            margin-bottom: 10px;

            border: 1px solid #80868D;
            border-radius: 5px;
            text-align: center;
            box-sizing: border-box;
            cursor: pointer;
            opacity: .6;

            &:hover {
                opacity: 1;
            }
            img {
                width: 100%;
                height: 40px;
                max-width: none;
                margin: 0;
                cursor: pointer;
            }



        }
    }
}

.mobile-wrapper-buttons {
    display: none;

    .buttons-list {
        button {
            margin: 0;
        }
    }
}

.cold-stock-mobile {
    width: 100%;
}
</style>
